import React, { useEffect,useContext } from 'react';
import { AuthContext } from '../../context/auth-context';
import { useInvalidateQuery } from '../../hooks/invalidate-query';
import { useSocket } from '../../context/socket-io-context';
import { useSnackbar } from '../../context/snackbar-context';

const NotificationsList = {
    newMessage: 'newMessage',
    newJobApplications: 'newJobApplications',
    newRecruitmentOffer: 'newRecruitmentOffer',
    newRecruitmentResponse: 'newRecruitmentResponse',
    newCreditPurchase: 'newCreditPurchase',
    newPostLike: 'newPostLike',
    newPostComment: 'newPostComment',
    newCommentLike: 'newCommentLike',
}

const SocketEventListener = () => {
    const auth = useContext(AuthContext);
    const { invalidateQuery } = useInvalidateQuery();
    const { socket } = useSocket();
    const { showSnackbar } = useSnackbar();
    useEffect(() => {
        if(!socket) return;

        socket.on(NotificationsList.newMessage, (data) => {
            const message = data?.message ?? "";
            const chatId = data?.chatId;
            const userData = data?.userData ?? {};
            const { name, image } = userData;

            invalidateQuery('dashboard-chat-messages');
            invalidateQuery('dashboard-chats');
            const text = message.slice(0,100) + (message.length > 100 ? '...' : '');
            showSnackbar({
                message: text,
                severity: 'info',
                path: `/users/${auth?.user?._id}?sendMessage=true&chatId=${chatId}`,
                image: image,
                name: name,
            });
        });

        socket.on(NotificationsList.newJobApplications, (data) => {
            const { applicantName, image, jobName } = data ?? {};
            invalidateQuery("userApplications");
            showSnackbar({
                message: `Application from ${applicantName} for ${jobName}`,
                severity: 'info',
                path: `/users/${auth?.user?._id}`,
                image: image ?? "",
                name: applicantName,
            })
        });

        socket.on(NotificationsList.newRecruitmentOffer, (data) => {
            const { jobTitle, salary, location, employerName, employerImage, recruitmentId } = data ?? {};
            invalidateQuery('RecruitmentData');
            showSnackbar({
                message: `Recruitment Offer! ${jobTitle} - ${salary} - ${location}`,
                severity: 'info',
                path: `/users/${auth?.user?._id}`,
                image: employerImage ?? "",
                name: employerName,
            })
            if (auth?.user && recruitmentId) {
                auth.updateUser({
                    ...auth.user,
                    recruitmentReceived: [
                        ...(auth.user.recruitmentReceived || []),
                        recruitmentId,
                    ],
                });
            }
        });

        socket.on(NotificationsList.newRecruitmentResponse, async(data) => {
            const { teacherName, teacherImage, teacherResponse } = data ?? {};
            await invalidateQuery('employerRecruits');
            showSnackbar({
                message: `${teacherName} has responded with - "${teacherResponse}"`,
                severity: 'info',
                path: `/users/${auth?.user?._id}`,
                image: teacherImage ?? "",
                name: teacherName,
            })
           
        });

        socket.on(NotificationsList.newPostLike, (data) => {
            const firstName = data?.firstName || "Someone";
            showSnackbar({
                message: `${firstName} liked your post`,
                severity: 'info',
                name: firstName,
            });
        });

        socket.on(NotificationsList.newPostComment, (data) => {
            const firstName = data?.firstName || "Someone";
            showSnackbar({
                message: `${firstName} commented on your post`,
                severity: 'info',
                name: firstName,
            });
        });

        socket.on(NotificationsList.newCommentLike, (data) => {
            const firstName = data?.firstName || "Someone";
            showSnackbar({
                message: `${firstName} liked your comment`,
                severity: 'info',
                name: firstName,
            });
        });

        return () => {
            socket.off(NotificationsList.newMessage);
            socket.off(NotificationsList.newJobApplications);
            socket.off(NotificationsList.newRecruitmentOffer);
            socket.off(NotificationsList.newRecruitmentResponse);
            socket.off(NotificationsList.newPostLike);
            socket.off(NotificationsList.newPostComment);
            socket.off(NotificationsList.newCommentLike);
        };
    }, [socket]);
}

export default SocketEventListener;
